// extracted by mini-css-extract-plugin
export default {"btop":"cc66aa4ae3 _056e21d9b9 df2157c48c","icon":"_92d1ffa6cf _6cefd6f0df","btoppink":"_4f2343248e fcc252b40d"};